import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { CouponImage, DefaultCouponImage } from "@components";
import { ICoupon } from "@interfaces";
import { selectMerchant } from "@redux";

interface IProps {
    data: ICoupon & { parentId?: string };
    handleClickItem: (id: string, alienCode: string, parentId?: string) => void;
}

export const CouponItem = (props: IProps) => {
    //page props
    const { data, handleClickItem } = props;
    //page hook
    const { t } = useTranslation();
    //redux page
    const { themes } = useSelector(selectMerchant);

    // const dateFormat = dayjs(data?.endDate).format("DD/MM/YYYY");
    const dateFormat = dayjs(data?.endDate).format("DD/MM/YYYY");

    const isDateExpiry = dayjs(data?.endDate) < dayjs() ? true : false;

    return (
        <StyledContainer>
            <div className="body-text">
                <div className="name">{data.name}</div>
                <div className="date">
                    {t("page.expiration_date")}: <span className="eng"> {dateFormat}</span>
                    {isDateExpiry && <span className="absolute expireDate">Expire</span>}
                </div>
                <div className="button-layout">
                    {/* <div className="coupon-price eng">
                        {data.unit === enumUnit.PERCENTAGE
                            ? (data.benefit || 0) + "%"
                            : (data.benefit || 0) + "฿"}
                    </div> */}
                    <StyledUsedBtn
                        className={isDateExpiry ? "btn-expired" : "btn-redeem"}
                        themeColor={themes?.themeColor!}
                        isExpired={isDateExpiry}
                        onClick={() => {
                            !isDateExpiry &&
                                handleClickItem(
                                    data.qrToken || "",
                                    data?.alienCode || "",
                                    data?.parentId
                                );
                        }}
                    >
                        {t("page.redeem")}
                    </StyledUsedBtn>
                    <StyledUsedBtn
                        themeColor={themes?.themeColor!}
                        onClick={() =>
                            handleClickItem(
                                data.qrToken || "",
                                data?.alienCode || "",
                                data?.parentId
                            )
                        }
                    >
                        {t("page.detail")}
                    </StyledUsedBtn>
                </div>
            </div>
            <div className="img-layout">
                {data?.imageUrl?.length > 0 ? (
                    <CouponImage imageUrl={data?.imageUrl[0]} grayScale={isDateExpiry} />
                ) : (
                    <DefaultCouponImage color={themes?.themeColor!} />
                )}
            </div>
            {/* <div className="coupon-sector">
                <div />
            </div> */}
        </StyledContainer>
    );
};

const StyledUsedBtn = styled.button<{ themeColor: string; isExpired?: boolean }>`
    padding: 6px 13px;
    color: ${(p) => (p.isExpired ? "#fff" : p.themeColor)};
    background: ${(p) => (p.isExpired ? "#a9a9a9" : p.theme.colors.card)};
    border: 0.5px solid ${(p) => (p.isExpired ? "#a9a9a9" : p.themeColor)};
    border-radius: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;
const StyledContainer = styled.div`
    margin-right: 1px;
    border-radius: 14px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    background: ${(p) => p.theme.colors.card};
    position: relative;
    .img-layout {
        flex: 1;
        height: 120px;
        border-left: 3px dashed #e8e8e8;
        img {
            width: 100%;
            height: 100%;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
        }
        div {
            height: 100%;
            width: 100%;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-top-right-radius: 14px;
            border-bottom-right-radius: 14px;
        }
    }
    .body-text {
        flex: 2;
        padding: 12px;
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
        overflow: hidden;
        // border-right: 3px dotted #e1e1e1;
        .name {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 19px;
            color: ${(p) => p.theme.colors.color};
        }
        .desc {
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 14px;
            color: ${(p) => p.theme.colors.color};
            max-height: 34px;
            overflow: hidden;
            p {
                margin: 0;
            }
        }
        .date {
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 14px;
            color: #919191;

            p {
                margin: 0;
            }
        }
    }
    .absolute {
        border-radius: 5px;
        padding: 4px 8px;
        margin-left: 10px;
    }
    .expireDate {
        background-color: #cccccc;
        color: #919191;
    }
    .coupon-sector {
        background: ${(p) => p.theme.colors.background};
        width: 30px;
        height: 30px;
        border-radius: 50%;
        position: absolute;
        top: 49%;
        transform: translateY(-50%);
        right: -15px;
    }
`;
